import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteSummary } from 'app/_models/site-summary.model';
import { SiteForm } from 'app/_models/site-forms/site-form.model';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { SiteService } from 'app/_services/site.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'site-forms-link-sites-modal',
  templateUrl: './site-forms-link-sites-modal.component.html',
})
export class SiteFormsLinkSitesModalComponent implements OnInit {
  @Input() siteForm: SiteForm;

  public sitesList: SiteSummary[] = [];
  public selectedValues: number[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private siteFormsService: SiteFormsService,
    private siteService: SiteService,
  ) { }

  ngOnInit() {
    this.selectedValues = this.siteForm.linkedSites.map(s => s.siteId);

    this.siteService.getSiteListSummary().subscribe((sites: SiteSummary[]) => {
      this.sitesList = sites.filter((site: SiteSummary) => this.siteForm.siteOwnerSkylarkUser === site.siteOwnerSkylarkUserId);
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }


  public onSubmit() {
    const body = {
      name: this.siteForm.name,
      formData: JSON.stringify(this.siteForm.data),
      sites: this.selectedValues,
    };

    this.siteFormsService.updateForm(this.siteForm.id, body).subscribe(result => {
      Swal.fire('Updated!', 'Site links to this form have been updated', 'success');
      this.activeModal.close('refresh');
    });
  }
}
